import React from 'react';
import { DiscountType } from '../../types/Voucher';
import { Currency } from '@flixbus/honeycomb-react';

// Define the props
interface DiscountBalanceProps {
  discountType: DiscountType;
}

const DiscountBalance: React.FC<DiscountBalanceProps> = ({ discountType }) => {
  if ('discount' in discountType) {
    return (
      <>
        <Currency value={discountType.discount.amount} code={discountType.discount.currency} />
      </>
    );
  }

  if (discountType.type === 'percentage_marketing') {
    return <>{discountType.percentage * 100}%</>;
  }

  return <></>;
};

export default DiscountBalance;
